import Modal from 'react-modal';
import PropTypes from 'prop-types';
import Button, { BUTTON_TYPES } from '../../Button';
import "../../../styles/AdminPage.css";
import { FaTimes } from "react-icons/fa";
import TextInput from '../../inputs/TextInput';
import NumberInput from '../../inputs/NumberInput';
import React , {useEffect, useState} from 'react';
import { createSemester, createSwagItem, deleteSwagItem, updateSemester, updateSwagItem } from '../../../api/admin/AdminSettingsAPI';
import DateInput from '../../inputs/DateInput';
import InputContainer from './InputContainer';
import AdminSettingsEditModal from './AdminSettingsEditModal';
import toast from 'react-hot-toast';

Modal.setAppElement('#root');

const EditSemesterModal = ({ isOpen, onClose, isAdding, item, setItems }) => {    
    const [semesterTitle, setSemesterTitle] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    useEffect(() => {
        if (!isAdding && item) {
            setSemesterTitle(item.semesterTitle);
            setStartDate(item.startDate);
            setEndDate(item.endDate);
        }
    }, [isAdding, item]);

    const modalTitle = isAdding ? "Add Semester" : "Edit Semester";

    const handleConfirm = async () => {
        let data;

        if (isAdding) {
            data = {
                semesterTitle,
                startDate,
                endDate
            };
            try {
                toast.loading("Creating Semester...");

                const response = await createSemester(data);
                setTimeout(async () => {
                        if (response.ok) {
                            toast.dismiss();
                            try {
                                const newSemester = await response.json();
                                toast.success("Semester created!");
                                setItems((prev) => [...prev, newSemester]);
                                onClose();
                            } catch (jsonError) {
                                console.error("Error parsing JSON:", jsonError);
                                toast.error("Error parsing server response.");
                            }
                        } else {
                            toast.dismiss();
                            console.log("Error creating semester. Status:", response.status);
                            toast.error("Semester failed to create. Status: " + response.status);
                        }
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting semester:", error);
                alert("Something went wrong. Please check your connection and try again.");

            }
        } else {
            data = {
                id: item.id,
                semesterTitle: semesterTitle,
                startDate: startDate,
                endDate: endDate
            };

            try {
                toast.loading("Updating Semester...");

                const response = await updateSemester(data);
                setTimeout(async () => {
                        if (response.ok) {
                            toast.dismiss();
                            try {
                                toast.success("Semester updated!");
                                setItems((prev) => prev.map(s => s.id === item.id ? data : s));
                                onClose();
                            } catch (jsonError) {
                                console.error("Error parsing JSON:", jsonError);
                                toast.error("Error parsing server response.");
                            }
                        } else {
                            toast.dismiss();
                            console.log("Error updating semester. Status:", response.status);
                            toast.error("Semester failed to update. Status: " + response.status);
                        }
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting semester:", error);
                alert("Something went wrong. Please check your connection and try again.");

            }
        }
    };

    const content = (
        <>
            <InputContainer>
                <TextInput
                    id="swag-name"
                    label='Semester Title'
                    className="edit-swag-text form-input"
                    charLimit={80}
                    value={semesterTitle}
                    setValue={(e) => setSemesterTitle(e.target.value)}
                />
            </InputContainer>
            <InputContainer>
                <label className='input-label' htmlFor="semesterStartDate">Start Date</label>
                <input
                    type="date"
                    id="semesterStartDate"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                />
            </InputContainer>
            <InputContainer>
                <label className='input-label' htmlFor="semesterEndDate">End Date</label>
                <input
                    type="date"
                    id="semesterEndDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                />
            </InputContainer>
        </>
    );

    return (
        <AdminSettingsEditModal
            modalTitle={modalTitle}
            content={content}
            isOpen={isOpen}
            onClose={onClose}
            handleConfirm={handleConfirm}
        />
    );
};

EditSemesterModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default EditSemesterModal;
